import { World } from '@ecs/World';
import { Entity } from '@ecs/Entity';
import { ComponentType } from '@ecs/Component';

export abstract class System {
  protected world!: World;
  protected requiredComponents: ComponentType<any>[] = [];

  setWorld(world: World): void {
    this.world = world;
  }

  abstract update(deltaTime: number): void;

  protected getEntitiesWithComponents(...components: ComponentType<any>[]): Entity[] {
    return this.world.getEntitiesWithComponents(...components);
  }
}